module.exports = __webpack_public_path__ + "static/img/analyticsboard.bf5ec88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/analyticsboard.svg
// module id = rR+j
// module chunks = 58